module.exports = "<span bind-dynamic-page=\"$ctrl.templateHtml\" ng-repeat=\"entity in $ctrl.data\"></span>\n"


//////////////////
// WEBPACK FOOTER
// ./client/~ap/components/suite-entity-template-iter/suite-entity-template-iter.component.html
// module id = 996
// module chunks = 0